"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var crypto_1 = __importDefault(require("crypto"));
var hash = __importStar(require("./hash"));
var encryption = __importStar(require("./encryption"));
var random = __importStar(require("./random"));
function deprecationNotice(msg) {
    console.log("crypto-extra: " + msg);
}
module.exports = Object.assign(crypto_1["default"], {
    hash: hash.hash,
    encrypt: encryption.encrypt,
    decrypt: encryption.decrypt,
    randomString: random.randomString,
    randomNumber: random.randomNumber,
    randomKey: random.randomKey,
    generateKey: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        deprecationNotice("`generateKey` has been renamed to `randomKey`");
        return random.randomKey.apply(random, args);
    }
});
